import { render, staticRenderFns } from "./TabReport.vue?vue&type=template&id=79b56130"
import script from "./TabReport.vue?vue&type=script&lang=js"
export * from "./TabReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports